import { Fragment, useMemo } from "react"
import PullToRefresh from "react-simple-pull-to-refresh"

import { LoadingSpinner } from "@/components/shared/ui/loading-spinner"
import { StandardGuide, WorkingTapHighGMV } from "@/features/jobs/manage/components/working"
import { ECampaignType, ESubmitStatus } from "@/modules/helpers/enum"
import type { Potential } from "@/modules/types"

interface StatusProgressProps {
  submissionId?: string
  potentials?: Potential[]
  disabled?: boolean
  isRefetching?: boolean
  type?: ESubmitStatus
  campaignType?: ECampaignType
  submitStatus?: ESubmitStatus
  totalClip?: number
  isCastCamp: boolean
  refetch: () => void
  loading: boolean
  draftList: any[]
  workingAt: string
}

const colorIndex = {
  0: "#3EE4AF",
  1: "#85E7C8",
  2: "#31AE95"
}

const groupDraftsByVersion = (drafts: any[]) => {
  const grouped: { [key: string]: any[] } = {}
  drafts.forEach((draft) => {
    const version = Math.floor(draft.version)
    if (!grouped[version]) grouped[version] = []
    grouped[version].push(draft)
  })
  return grouped
}

export const GuideInstructions: React.FC<StatusProgressProps> = ({
  submissionId,
  potentials,
  disabled,
  campaignType = ECampaignType.REVIEW_PRODUCT,
  totalClip,
  isCastCamp,
  refetch: refetchParent,
  loading,
  draftList,
  workingAt
}) => {
  const groupedDrafts = useMemo(() => groupDraftsByVersion(draftList || []), [draftList])

  return (
    <PullToRefresh
      onRefresh={async () => {
        refetchParent()
      }}
      pullingContent=""
      refreshingContent={<LoadingSpinner className="w-20 h-20" />}
      maxPullDownDistance={80}
    >
      {loading ? (
        <LoadingSpinner className="w-20 h-20" />
      ) : (
        <>
          {/* Clip sections */}
          {Array(totalClip)
            .fill(0)
            .map((_, index) => (
              <Fragment key={index}>
                {!isCastCamp ? (
                  <WorkingTapHighGMV
                    color={colorIndex[index as keyof typeof colorIndex]}
                    refetch={() => {
                      refetchParent()
                    }}
                    workingAt={workingAt}
                    campaignType={campaignType}
                    demoIndex={index + 1}
                    potentials={potentials}
                    submissionId={submissionId}
                    list={groupedDrafts[index + 1] || []}
                    disabled={disabled}
                  />
                ) : (
                  <StandardGuide
                    color={colorIndex[index as keyof typeof colorIndex]}
                    refetch={() => {
                      refetchParent()
                    }}
                    workingAt={workingAt}
                    campaignType={campaignType}
                    demoIndex={index + 1}
                    potentials={potentials}
                    submissionId={submissionId}
                    list={groupedDrafts[index + 1] || []}
                    disabled={disabled}
                  />
                )}
              </Fragment>
            ))}
        </>
      )}
    </PullToRefresh>
  )
}
